import { PortOfEntry } from '../models/utilities/port-of-entry';
import { ServiceCenter } from '../models/utilities/service-center';
import { ToastMessage } from '../models/utilities/toast-message';
import { UserNotification } from '../models/utilities/user-notification';
import { BaseModuleState } from './_BaseModuleState';

export class UtilityState extends BaseModuleState {

    public isLoading            : boolean = false;
    public isDownloading        : boolean = false;

    public appServiceCenters    : ServiceCenter[]; 
    public portOfEntries        : PortOfEntry[];
    public toasts               : ToastMessage[] = [];

    public notifications        : UserNotification[] = [];
    public signalRConnected     : boolean = false;


    public scrollState : any = {};

    constructor() {
        super();

        this.portOfEntries = this.buildPortOfEntries();
        this.appServiceCenters = this.buildServiceCenters();

    }

    private buildServiceCenters() {
        return [
            new ServiceCenter({
                id: 1, 
                name: 'ALL', 
                description: 'All Service Centers', 
                timezone: 'America/Chicago',
                latitude: 0.1,
                longitude: 0.1
            }),
            new ServiceCenter({
                id: 2, 
                name: 'MAIN', 
                description: 'Arthur, IL', 
                timezone: 'America/Chicago',
                latitude: 39.708579, 
                longitude: -88.455089
            }),
            new ServiceCenter({
                id: 3, 
                name: 'CA1', 
                description: 'Lathrop, CA', 
                timezone: 'America/Los_Angeles',
                latitude: 37.784678, 
                longitude: -121.288743
            }),
            new ServiceCenter({
                id: 4, 
                name: 'CA2', 
                description: 'Ontario, CA', 
                timezone: 'America/Los_Angeles',
                latitude: 34.054470,
                longitude: -117.553464
            }),
            new ServiceCenter({
                id: 5, 
                name: 'CO', 
                description: 'Denver, CO', 
                timezone: 'America/Denver',
                latitude: 39.801039, 
                longitude: -104.990339
            }),
            new ServiceCenter({
                id: 6, 
                name: 'NEW JERSEY', 
                description: 'Lyndhurst, NJ', 
                timezone : 'America/New_York',
                latitude: 40.797274, 
                longitude: -74.103025
            }),
            new ServiceCenter({
                id: 7, 
                name: 'NH', 
                description: 'Derry, NH', 
                timezone: 'America/New_York',
                latitude: 42.9005346, 
                longitude: -71.3326124
            }),
            new ServiceCenter({
                id: 8, 
                name: 'IN', 
                description: 'Terre Haute, IN', 
                timezone: 'America/Indiana/Indianapolis',
                latitude: 39.5033756, 
                longitude: -87.3548106
            }),
            new ServiceCenter({
                id: 9,
                name: 'IN PX',
                description: 'Terre Haute, Performax',
                timezone: 'America/Indiana/Indianapolis',
                latitude: 39.5033756,
                longitude: -87.3548106
            })
        ];
    }

    private buildPortOfEntries() {
        return [
            new PortOfEntry(329, "Armstrong"),
            new PortOfEntry(507, "Boissevain"),
            new PortOfEntry(707, "Carway"),
            new PortOfEntry(215, "Centerville"),
            new PortOfEntry(705, "Coutts"),            
            new PortOfEntry(502, "Emerson"),
            new PortOfEntry(610, "Estevan Highway"),
            new PortOfEntry(410, "Fort Erie"),
            new PortOfEntry(503, "Gretna"),
            new PortOfEntry(817, "Huntingdon"),
            new PortOfEntry(818, "Kingsgate"),
            new PortOfEntry(351, "Lacolle"),
            new PortOfEntry(456, "Lansdowne"),
            new PortOfEntry(427, "Niagara Falls"),
            new PortOfEntry(602, "North Portal"),
            new PortOfEntry(819, "Osoyoos"),
            new PortOfEntry(813, "Pacific Highway"),
            new PortOfEntry(517, "Piney"),
            new PortOfEntry(439, "Prescott"),
            new PortOfEntry(607, "Regway"),
            new PortOfEntry(314, "Rock Island Hwy 55"),
            new PortOfEntry(440, "Sarnia"),
            new PortOfEntry(453, "Windsor Ambassador Bridge"),
            new PortOfEntry(212, "Woodstock"),
            new PortOfEntry(308, "Woburn"),
            new PortOfEntry(328, "St-Armand/Philipsburg")
        ];
    }

}
